import { lazy, Suspense } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from '../../auth/useAuth';
import { getRuntimeConfig } from '../../config/runtime-config';
import { twinRouteDecision } from './twin-route';

// Lazy is not a preference here. three.js is ~150 KB gzipped, and the main
// bundle sits at 211 KB against a 460 KB budget -- a static import would spend
// two thirds of the remaining headroom on a route most sessions never open.
const TwinScreen = lazy(() => import('./TwinScreen').then((m) => ({ default: m.TwinScreen })));

/**
 * The `/twin` route: the showcase for the demo role, a redirect to the
 * Overview's Building view for everyone and everything else
 * (`twin-route.ts` has the rules and why).
 *
 * The redirect REPLACES `/twin` in the history, so Back from the Overview
 * goes to wherever the link was opened from, not into a redirect loop.
 */
export function TwinRoute() {
  const { roles } = useAuth();
  const { search } = useLocation();
  const decision = twinRouteDecision({
    roles,
    search,
    twinEnabled: getRuntimeConfig().featureFlags.twinEnabled,
  });
  if (decision.kind === 'redirect') return <Navigate to={decision.to} replace />;
  return (
    <Suspense fallback={null}>
      <TwinScreen />
    </Suspense>
  );
}
